import gsap from 'gsap';

class FilterGrid {
  constructor(element) {
    this.element = element

    this.permalink = this.element.dataset.permalink

    this.filterTypeToButton = {}
    this.filterTypeToOptionGroup = {}

    this.filterContainer = this.element.querySelector('.js-filter-grid__filter-wrapper')

    this.handleFilterTypeClick = this.handleFilterTypeClick.bind(this)
    this.handleOptionGroupSelectChange = this.handleOptionGroupSelectChange.bind(this)
    this.handleOptionGroupSelectClick = this.handleOptionGroupSelectClick.bind(this)
    this.handlePopstate = this.handlePopstate.bind(this)

    this.handleFilterTransitionOutComplete = this.handleFilterTransitionOutComplete.bind(this)
    this.handleMoreButtonClick = this.handleMoreButtonClick.bind(this)

    this.perPage = parseInt(this.element.dataset.perPage) || null
    this.totalPages = 1;

    this.moreButton = this.element.querySelector('.events__pagination a')

    this.showTimeout = null;
  }

  handleFilterTypeClick(event) {
    const filterTypeButton = event.target.hasAttribute('data-filter-type') && event.target || event.target.closest('[data-filter-type]')
    this.activateFilterByType(filterTypeButton.dataset.filterType, filterTypeButton.dataset.filterValue)
  }

  activateFilterByType(filterType, filterValue) {

    // query for the corresponding filter option group
    const filterOptionGroup = this.filterTypeToOptionGroup[filterType]

    let filterTypeButton = this.filterTypeToButton[filterType]
    if (typeof this.filterTypeToButton[`${filterType}-${filterValue}`] !== 'undefined') {
      filterTypeButton = this.filterTypeToButton[`${filterType}-${filterValue}`]
    }

    this.deactivateCurrentFilter(filterType, filterValue)

    this.currentFilterType = filterType

    if (filterTypeButton) {
      filterTypeButton.classList.add('active')
    }

    if (filterOptionGroup) {
      filterOptionGroup.classList.add('active')
    } else {

      if (filterValue) {
        this.updateFilterState(filterValue)
        return;
      }

      // Selected filter doesn't have any related options
      // Update the filter state with the type as the value
      this.updateFilterState(filterType)
    }
  }

  deactivateCurrentFilter(newFilterType, newFilterValue) {

    const activeItems = [...this.filterContainer.querySelectorAll('.active')]
    activeItems.forEach((item) => {
      item.classList.remove('active')
    })



    // // New filter is the same. Just leave it.
    // if (this.currentFilterType && this.currentFilterType == newFilterType && this.currentFilterValue === newFilterValue) {
    //   return;
    // }

    // if (!this.currentFilterType) {
    //   return;
    // }

    // let currentType = this.currentFilterType
    // // if (this.currentFilterType == 'type' && this.currentFilterValue == '') {
    // //   currentType = 'all'
    // // }

    // let filterTypeButton = this.filterTypeToButton[currentType]

    // if (typeof this.filterTypeToButton[`${currentType}-${this.currentFilterValue}`] !== 'undefined') {
    //   filterTypeButton = this.filterTypeToButton[`${currentType}-${this.currentFilterValue}`]
    // }

    // const filterTypeOptionGroup = this.filterTypeToOptionGroup[this.currentFilterType]

    // if (filterTypeButton) {
    //   filterTypeButton.classList.remove('active')
    // }

    // if (filterTypeOptionGroup) {
    //   filterTypeOptionGroup.classList.remove('active')
    // }
  }

  handleOptionGroupSelectChange(event) {
    const filterValue = event.target.options[event.target.selectedIndex].value
    this.updateFilterState(filterValue, { reset: true })
  }

  handleOptionGroupSelectClick(event) {
    this.updateFilterState(event.target.dataset.filterValue)
  }

  setupFilterOptionGroupEvents(optionGroupElem) {

    optionGroupElem.addEventListener('change', this.handleOptionGroupSelectChange)

    optionGroupElem.querySelectorAll('button').forEach((filterButton) => {
      filterButton.addEventListener('click', this.handleOptionGroupSelectClick)
    })
  }

  updateFilterState(filterValue, options) {

    options = { pushState: true, ...options, }

    let permalink = this.permalink.replace(/\/?$/, '');
    let stateUrl = `${permalink}/${this.currentFilterType}/${filterValue}/`

    if (filterValue === 'all') {
      stateUrl = this.permalink
    }

    const urlParams = new URLSearchParams(window.location.search)
    let pageUrlPart = '';
    if (this.uptoPage && this.uptoPage != 1) {
      urlParams.set('page_num', this.uptoPage)
      pageUrlPart = `?${urlParams.toString()}`
    }

    if (options.pushState) {
      window.history.pushState({ type: this.currentFilterType, value: filterValue, }, '', `${stateUrl}${pageUrlPart}`)
    }

    this.currentFilterValue = filterValue

    this.setActiveFilter(this.currentFilterType, filterValue)
    this.updateResults(this.currentFilterType, filterValue)
  }

  updatePageState() {

    let permalink = this.permalink.replace(/\/?$/, '');
    let stateUrl = `${permalink}/${this.currentFilterType}/${this.currentFilterValue}/`
    if (this.currentFilterType === 'all') {
      stateUrl = `${permalink}/`
    }

    const urlParams = new URLSearchParams(window.location.search)
    urlParams.set('page_num', this.currentPage)

    window.history.pushState({ type: this.currentFilterType, value: this.currentFilterValue, page: this.currentPage }, '', `${stateUrl}?${urlParams.toString()}`)
  }

  setActiveFilter(filterType, filterValue) {
    Object.keys(this.filterTypeToOptionGroup).forEach((optionGroupType) => {
      const optionGroup = this.filterTypeToOptionGroup[optionGroupType]

      if (!optionGroup) {
        return;
      }

      const selectedOption = optionGroup.querySelector('.selected')
      if (selectedOption) {
        selectedOption.classList.remove('selected')
      }
    })

    const filterOptionGroup = this.filterTypeToOptionGroup[filterType]
    if (filterOptionGroup) {
      const optionButton = filterOptionGroup.querySelector(`[data-filter-value="${filterValue}"]`)
      if (optionButton) {
        optionButton.classList.add('selected')
      }

      const filterSelect = filterOptionGroup.querySelector('select')
      if (filterSelect) {
        const filterSelectOption = filterSelect.querySelector(`[value=${filterValue}]`)
        if (filterSelectOption) {
          filterSelectOption.selected = true
        }
      }
    }
  }

  handlePopstate(event) {
    if (event.state) {
      if (event.state.type) {
        this.activateFilterByType(event.state.type)
        this.updateFilterState(event.state.value, { pushState: false })
      }
    }
  }

  updateResults(filterType, filterValue) {
    gsap.to(this.filterItemsContainer, {
      opacity: 0,
      duration: .2,
      onComplete: this.handleFilterTransitionOutComplete,
      onCompleteParams: [filterType, filterValue],
    })
  }

  getResultsForPage() {

    if (!this.perPage) {
      this.perPage = this.items.length
    }

    if (this.uptoPage) {
      const start = 0;
      return this.items.slice(start, this.uptoPage * this.perPage)
    }

    const start = (this.currentPage - 1) * this.perPage;
    return this.items.slice(start, start + this.perPage)
  }

  handleFilterTransitionOutComplete(filterType, filterValue) {
    this.applyFilters(filterType, filterValue)

    this.filterItemsContainer.style.opacity = 1;
    this.filterItemsContainer.classList.remove('js-filter-grid__items--default-sort')

    this.showItemsForPage()
  }

  disableFilterItem(filterItem) {
    filterItem.style.display = 'none';
  }

  prepFilterItemForDisplay(filterItem) {
    filterItem.style.display = '';
    gsap.set(filterItem, { opacity: 0, y: '10%', })
  }

  applyFilters(filterType, filterValue) {

    if (filterType === 'all') {
      this.items = this.filterItems
      this.items.forEach((filterItem) => {
        this.disableFilterItem(filterItem)
      })
      this.setupPagination(true)
      return this.items
    }

    this.items = this.filterItems.filter((filterItem) => {

      if (typeof filterItem.dataset[filterType] === 'undefined') {
        this.disableFilterItem(filterItem)
        return false;
      }

      try {
        let values = JSON.parse(filterItem.dataset[filterType])

        if (!values ||
          Array.isArray(values) && !values.includes(filterValue) ||
          values === filterValue
          ) {
          this.disableFilterItem(filterItem)
          return false;
        }

        this.disableFilterItem(filterItem)
        return true;

      } catch(e) {
        this.disableFilterItem(filterItem)
        return false;
      }

      return false;
    })

    this.setupPagination(true)

    return this.items;
  }

  setupPagination(reset) {

    if (reset) {
      this.currentPage = this.uptoPage || 1
    }

    this.totalPages = 1
    if (this.perPage) {
      this.totalPages = Math.ceil(this.items.length / this.perPage)
    }

    if (!this.hasMorePages()) {
      this.element.classList.add('disable-pagination')
    } else {
      this.element.classList.remove('disable-pagination')
    }
  }

  updateFiltersFromDefaultState() {
    if (this.defaultFilterState) {
      this.currentFilterType = this.defaultFilterState.filter_type
      this.currentFilterValue = this.defaultFilterState.filter_value;

      this.currentPage = this.defaultFilterState.page_num
      this.uptoPage = this.defaultFilterState.page_num

      this.activateFilterByType(this.defaultFilterState.filter_type, this.defaultFilterState.filter_value)

      if (this.defaultFilterState.filter_type != 'all') {
        this.updateFilterState(this.defaultFilterState.filter_value, { pushState: false, })
      }
    }
  }

  showItemsForPage() {

    const displayItems = this.getResultsForPage();

    displayItems.forEach((displayItem) => {
      this.prepFilterItemForDisplay(displayItem)
    })

    gsap.to(displayItems, {
      opacity: 1,
      y: 0,
      stagger: .05,
      duration: .2,
      ease:"expo.easeInOut",
    })

    this.uptoPage = null
  }

  hasMorePages() {
    const nextPage = this.currentPage + 1
    const start = (nextPage - 1) * this.perPage;

    return this.items.slice(start, start + this.perPage).length > 0
  }

  showNextPage() {
    this.currentPage += 1;
    this.showItemsForPage()
    this.setupPagination()
    this.updatePageState()
  }

  handleMoreButtonClick(event) {
    event.preventDefault()
    this.showNextPage()
  }

  init() {
    this.filterTypeButtons = [...this.element.querySelectorAll('[data-filter-type]')]

    // Create an index for the filter types and option groups
    this.filterTypeButtons.forEach((filterTypeButton) => {

      let filterTypeKey = filterTypeButton.dataset.filterType;
      // In the instances where the value is defined directly on the button,
      // Make the key unique for the type by appending the value
      if (filterTypeButton.dataset.filterValue) {
        filterTypeKey = `${filterTypeKey}-${filterTypeButton.dataset.filterValue}`
      }

      this.filterTypeToButton[filterTypeKey] = filterTypeButton
      this.filterTypeToOptionGroup[filterTypeButton.dataset.filterType] = this.element.querySelector(`#filter-${filterTypeButton.dataset.filterType}`)

      // If there's an option group for the filter, setup event handling for it
      if (this.filterTypeToOptionGroup[filterTypeButton.dataset.filterType]) {
        this.setupFilterOptionGroupEvents(this.filterTypeToOptionGroup[filterTypeButton.dataset.filterType])
      }
    })

    // Setup event handlers for the filter type buttons
    this.filterTypeButtons.forEach((filterTypeButton) => {
      filterTypeButton.addEventListener('click', this.handleFilterTypeClick)
    })

    this.filterItemsContainer = this.element.querySelector('.js-filter-grid__items')
    this.filterItems = [...this.element.querySelectorAll('.js-filter-grid__item')]

    // Set the default state from the view
    this.defaultFilterState = window.defaultFilterState;
    this.updateFiltersFromDefaultState()

    if (this.moreButton) {
      this.moreButton.addEventListener('click', this.handleMoreButtonClick)
    }

    window.addEventListener('popstate', this.handlePopstate)
  }
}

export default FilterGrid;

